import { ID, ListApiResponse } from '@ianesthesie-kit/services';
import { Allergy } from './allergy.model';
import { ListMedicalService, MedicalResponse } from '../baseMedical.service';
import axios, { AxiosResponse } from 'axios';

export class AllergyService extends ListMedicalService<Allergy> {
  public static readonly SC_CLEARED_CODE = 'NONE';
  private static INSTANCE_BY_ID: AllergyService;

  private scClearedAllergy?: Allergy;

  private constructor(patientId: string) {
    super('/allergy', patientId);
  }

  public static getInstance(patientId: ID): AllergyService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new AllergyService(patientId);
    }
    return this.INSTANCE_BY_ID;
  }

  isCleared() {
    return !!this.getScClearedAllergy();
  }

  isNotCleared() {
    return !this.isCleared();
  }

  getScClearedAllergy() {
    return this.scClearedAllergy;
  }

  fetch(
    params: Record<string, any> = {}
  ): Promise<MedicalResponse<Allergy, true>> {
    return super.fetch(params).then((resp) => {
      this.scClearedAllergy = resp.data.find(
        (al) => al.substanceCode === AllergyService.SC_CLEARED_CODE
      );

      return {
        ...resp,
        data: resp.data.filter(
          (al) => al.substanceCode !== AllergyService.SC_CLEARED_CODE
        )
      };
    });
  }

  public replace(
    allergies: Partial<Allergy>[]
  ): Promise<MedicalResponse<Allergy, true>> {
    const body = allergies.map((a) => this.transformToRequestBody(a));
    return axios
      .put(this.url, body)
      .then((response: AxiosResponse<ListApiResponse<Allergy>>) => ({
        data: response.data.data.map((d) => this.transformResponseEntity(d))
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  public reset(): Promise<MedicalResponse<Allergy, true>> {
    return this.deleteAt();
  }
}
